<template>
  <div class="col-12">
    <table class="table table-bordered bg-white table-sm">
      <tbody>
        <tr>
          <td>
            ID: <b>{{ item.id }}</b> Protocolo: <b>{{ item.protocolo }}</b>
          </td>
          <td>
            Data Cadastro:<b>{{ item.cadastrado }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Técnico:
            <b v-if="item.responsavel">{{ item.responsavel.name }}</b> -
            <span>
              {{ item.responsavel.tecnico.profissao ?? "Não informado" }}
            </span>
          </td>
          <td>
            Atualizado:<b>{{ item.atualizado }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Unidade:<b v-if="item.unidade">{{ item.unidade.nome }}</b>
          </td>
          <td>Status:<b v-html="item.status_nome"></b></td>
        </tr>
        <tr v-if="item.tecnicos">
          <td colspan="2">
            Outro(s) Técnico(s):
            <b
              class="badge badge-light mr-2"
              v-for="(tecnico, index) in item.tecnicos"
              :key="index"
            >
              {{ tecnico.nome }}
            </b>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Nome Completo do(a) Usuário(a)
            <b>
              <template v-if="item.solicitacao">
                {{ item.solicitacao.nome_usuario || item.nome_acolhido }}
                <span v-if="item.solicitacao.idade">, {{ item.solicitacao.idade }} Ano(s)</span>
              </template>
              <template v-else>
                {{ item.nome_acolhido }}
                {{ item.usuario_idade ? `, ${item.usuario_idade} Ano(s)` : "" }}
                <b-link
                  :to="'/dashboard/usuario/edit/' + item.usuario_id"
                  target="_blank"
                  :title="$t('Ver Prontuário do usuário')"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-external-link-alt"></i>
                </b-link>
              </template>
            </b>
          </td>
        </tr>
        <tr v-if="item.solicitacao">
          <td colspan="2">
            Nome Social: <b>{{ item.solicitacao.nome_social }}</b>
          </td>
        </tr>
        <tr v-else-if="item.idoso">
          <td colspan="2">
            Nome Social:
            <b>{{ item.idoso.nome_social }} </b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["item", "tipo"],
};
</script>
